import type { ReactNode, PropsWithChildren } from 'react';

import { TextEllipsis } from '../../typography/text-ellipsis/TextEllipsis.js';

/**
 * Typeguard to check if the children is only a single string.
 */
function hasSingleStringChild(children: ReactNode): children is string {
  return !Array.isArray(children) && typeof children === 'string';
}
/**
 * Typeguard to check if the children are an array of strings.
 */
function hasArrayOfStringChildren(children: ReactNode): children is string[] {
  return (
    Array.isArray(children) &&
    children.every((child) => typeof child === 'string')
  );
}

/** Helper component to wrap the children into a TextEllpipsis if valid.
 * @internal
 */
export function TextEllipsisAroundChildren(props: Readonly<PropsWithChildren>) {
  const { children } = props;
  if (hasSingleStringChild(children)) {
    return <TextEllipsis>{children}</TextEllipsis>;
  }
  if (hasArrayOfStringChildren(children)) {
    return <TextEllipsis>{children.join('')}</TextEllipsis>;
  }

  return children;
}
